/**
 * Because the environment.ts file is replaced on a production build
 * it is safer to provide a base that other environment files can extend on.
 *
 * This way the base is not removed in a production environment.
 */

import { IAppEnvironment } from './environment.types';

export const base: IAppEnvironment = {
  PRODUCTION: false,
  DEVELOP: false,
  BACKEND_URL: '/suite-backend',
  OLD_BACKEND_URL: '/suite',
  WS_URL: 'wss://' + location.host + '/suite-backend/websocket',
  WS_URL_SUITE: 'wss://' + location.host + '/suite/websocket',
  USERNAME: null,
  USERID: null,
  BEARER_TOKEN: null,
  PSPDFKIT_KEY: null,
  PDF_VIEW_TOKEN:
    'MjkyNzQ1ODc1MjAwNjQ4NjEyNzU5NjgyNjI4MzgzMDk2Mzc1NjgwMDU0MzkwMzIwNDc2MzY0MjYxMDkzODMwOTQ0MzgwNzMxMDU5MjY5NTk3NjIzMTYwMzA2OTY0NjMyMTk5Mjk1NDc2OTU2MTIyMTg2NzIyMTA5MjgzNTQxNjQxNzY1Mjc1OTUzNTQ1MDY3NTIwMzEzODMyNDg3NDUzOTM4OTIwMjQ0OTMzMDM4NjIyNDQ2MTQ5MTAyNDgwNTkxODMzOTcyNTM1NzQ3NzYwODQ3MTAzNzQ0OTA'
};
